import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: '#131323',
        secondary: '#13344f',
        accent: '#304156',
        error: '#FF5252',
        info: '#409EFF',
        success: '#4CAF50',
        warning: '#FFC107',
        wsColor: '#610C9F',
        wsPrimary:'#131323',
        wsRed:'#e01c24',
        weBlue:'#244493'
      },
      dark: {
        primary: '#5A5843', //#5A5843,//#060607 #CD3015
        secondary: '#A4A4A4',
        accent: '#59210D',
        error: '#FF5252',
        warning: '#9A8F65',
        info: '#CED0D1',
        success: '#4b8a03'//'#8bc34a'
      }
    }
  }
})
